// import TweenMax from 'gsap';


// Parallax
jQuery( ".parallax" ).on( 'mousemove', function( e ) {
  parallaxIt( e, ".parallax .front", 35 );
  parallaxIt( e, ".parallax .back", 10 );
} );

function parallaxIt( e, target, movement ) {
  const $this = jQuery( ".parallax" );
  const relX = e.pageX - $this.offset().left;
  const relY = e.pageY - $this.offset().top;

  TweenMax.to( target, {
    // Default
    duration: 1,
    x: ( relX - $this.width() / 2 ) / $this.width() * movement - 10,
    y: ( relY - $this.height() / 2 ) / $this.height() * movement
  } );
}

const heroSliders = document.querySelectorAll( '[data-slider="hero-banner-slider"]' );

heroSliders.forEach( slider => {
  if ( slider.dataset.parallax ) {
    console.log( 'has parallax' );
    slider.on( 'mousemove', function( e ) {
      parallaxIt( e, ".parallax .front", 35 );
      parallaxIt( e, ".parallax .back", 10 );
    } );
  }

  console.log( slider.getAttribute( 'data-slider-layout' ) );
  switch ( slider.getAttribute( 'data-slider-layout' ) ) {
    case 'full-screen':
      jQuery( slider ).slick( {
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: false,
        fade: true,
        autoplay: true,
        autoplaySpeed: 5000,
      } );
      break;
    case 'split':
      const images = slider.querySelector( '.split-banner-images-slider' );
      const content = slider.querySelector( '.split-banner-content-slider' );
      jQuery( images ).slick( {
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        asNavFor: content,
        arrows: false,
        fade: true,
        autoplay: true,
        autoplaySpeed: 5000,
      } );

      jQuery( content ).slick( {
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        asNavFor: images,
        arrows: false,
        fade: true,
        autoplay: true,
        autoplaySpeed: 5000,
      } );
      break;
    case 'cut-out':
      jQuery( slider ).slick( {
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows: false,
        fade: true,
        autoplay: true,
        autoplaySpeed: 5000,
      } );
      break;
    default:
      break;
  }
} );

